import React from 'react'
import MainLayouts from '../layouts/MainLayouts'
import BlankLayout from '../layouts/Blank'
import { ModuleProvider } from '../context/ModuleContext/ModuleContext'

const layouts = {
  home: MainLayouts,
  blank: BlankLayout,
}
const AppComponent = ({ layout }) => {
  if (layouts[layout]) {
    const ViewLayout = layouts[layout]
    return (
      <ModuleProvider>
        <ViewLayout />
      </ModuleProvider>
    )
  }
  return
}

export default AppComponent
